import { makeAutoObservable } from 'mobx';
import { createContext, useContext } from 'react';
import type { SyncType } from '../../../interfaces/Enums';

type JobType = SyncType;

type DatabuilderJobPollingState = {
	[integrationId: string]: {
		[jobType in JobType]?: boolean;
	};
};

class DatabuilderJobPollingStore {
	pollingState: DatabuilderJobPollingState = {};

	constructor() {
		makeAutoObservable(this);
	}

	setPollingState(integrationId: string, jobType: JobType, state: boolean) {
		this.pollingState[integrationId] = {
			...this.pollingState[integrationId],
			[jobType]: state,
		};
	}

	isPolling(integrationId: string, jobType: JobType) {
		return this.pollingState[integrationId]?.[jobType] || false;
	}
}

export const store = new DatabuilderJobPollingStore();

export const DatabuilderJobPollingContext =
	createContext<DatabuilderJobPollingStore>(store);

export function useDatabuilderJobPollingContext() {
	const context = useContext(DatabuilderJobPollingContext);
	if (context === undefined) {
		throw new Error('usePollingContext must be used within a PollingProvider');
	}
	return context;
}
